module.exports = __webpack_public_path__ + "static/me-35034fcf8968e6e0d812e50d818b2eef.png";